import { Directive, Input, ElementRef, AfterContentInit } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {
@Input() appAutoFocus:Boolean=false;

  constructor(private e1:ElementRef) { }
  ngAfterContentInit(): void {
    //console.log("auto focus");
   // throw new Error("Method not implemented.");
   setTimeout(()=>{
     this.e1.nativeElement.focus();
   },500);
  }

}
